// apps/landing-page/src/components/ui/EmptyState.tsx
interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
}

// Canonical empty state per docs/DESIGN_GUIDELINES.md §5 — icon, heading,
// optional supporting text, optional primary action. Use instead of ad-hoc
// dashed-border placeholders. Mirrors the same local component already used
// in apps/dashboard, apps/admin-dashboard, apps/partner-portal (no shared
// copy in @test-prep/ui yet).
export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-12 text-center">
      {icon && <div className="mb-1 text-slate-300">{icon}</div>}
      <p className="text-sm font-medium text-slate-700">{title}</p>
      {description && <p className="max-w-sm text-xs text-slate-400">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
